<template>
  <div class="dashboard-window dashboard-profile">
    <div class="profile-section" :class="{expanded: isProfileExpanded}">
      <div class="profile-label">
        <router-link to="/profile">
          <div :class="{highlighted: isInSettings}"
          class="profile-picture">
            <SettingsIcon class="settings-icon" />
            <img :src="profilePicture" alt="profile">
          </div>
        </router-link>
        <div class="profile-name">
          <h3>{{ profileName | shorten(20) }}</h3>
          <p>@{{ profileLogin | shorten(25) }}</p>
        </div>
        <div class="icon" @click="expandProfile">
          <ArrowDownIcon class="rotatable" :class="{rotated: isProfileExpanded}"/>
        </div>
      </div>
      <div class="other-profiles">
        <ul>
          <li
            v-show="currentProfileId != profiles.findIndex(x => x.id == profile.id)"
            @click="switchToProfile(profile.id)"
            v-for="profile in profiles"
            :key="profile.name"
          >
            <div class="other-profile-picture">
              <img :src="profile.profilePictureUrl" alt="profile">
            </div>
            <div class="profile-name">
              <h3>{{ profile.profileName | shorten(20) }}</h3>
              <p>@{{ profile.username | shorten(25) }}</p>
            </div>
          </li>
        </ul>
        <div @click="showModal('AddProfileModal')" class="add-profile-button">
          <PlusIcon />
          <p>Dodaj profil</p>
        </div>
      </div>
    </div>
    <div class="followers-label">
      <div class="followers">
        <h3 :class="{refreshing: isRefreshed}">{{ followers | shortenNumber }}</h3>
        <p>obserwujący</p>
      </div>
      <div class="followers">
        <h3 :class="{refreshing: isRefreshed}">{{ following | shortenNumber }}</h3>
        <p>obserwowani</p>
      </div>
      <div @click="refreshProfile" class="icon refresh-icon">
        <RefreshIcon class="rotatable" :class="{refreshed: isRefreshed}"/>
      </div>
    </div>
    <div class="balance-label">
      <div class="balance-title">
        <h3>Portfel</h3>
      </div>
      <div class="balance">
        {{ balance }}
        <span class="balance-symbol">PLN</span>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowDownIcon from '@/components/svgs/icons/ArrowDownIcon.vue';
import PlusIcon from '@/components/svgs/icons/PlusIcon.vue';
import RefreshIcon from '@/components/svgs/icons/RefreshIcon.vue';
import SettingsIcon from '@/components/svgs/icons/SettingsIcon.vue';

export default {
  name: "Profile",
  components: {
    ArrowDownIcon,
    PlusIcon,
    RefreshIcon,
    SettingsIcon
  },
  data() {
    return {
      isProfileExpanded: false,
      isRefreshed: false,
      isInSettings: false
    };
  },
  mounted() {
    this.refreshProfile();
    this.isInSettings = window.location.pathname === '/profile';
  },
  methods: {
    showModal(componentName) {
      this.$store.commit("showModal", componentName);
    },
    expandProfile() {
      this.isProfileExpanded = !this.isProfileExpanded;
    },
    refreshProfile() {
      // TODO: update followers info from api
      this.isRefreshed = !this.isRefreshed;
      setTimeout(() => {
        this.isRefreshed = !this.isRefreshed;
      }, 1000);
    },
    switchToProfile(id) {
      this.isProfileExpanded = false;
      setTimeout(() => {
        this.$store.dispatch("switchProfile", id);
      }, 500);
    }
  },
  computed: {
    balance() {
      return this.$store.getters.balance;
    },
    currentProfileId() {
      return this.$store.getters.currentProfileId;
    },
    followers() {
      return this.$store.getters.followers;
    },
    following() {
      return this.$store.getters.following;
    },
    profileLogin() {
      return this.$store.getters.profileLogin;
    },
    profileName() {
      return this.$store.getters.profileName;
    },
    profilePicture() {
      return this.$store.getters.profilePicture;
    },
    profiles() {
      return this.$store.getters.profiles;
    }
  },
  watch: {
    $route() {
      this.isInSettings = window.location.pathname === '/profile';
    }
  },
  filters: {
    shorten(value, maxLength) {
      if (!value) return "";
      const stringValue = value.toString();
      if (stringValue.length > maxLength) return `${stringValue.slice(0, maxLength)}...`;
      return stringValue;
    },
    shortenNumber(value) {
      if (!value) return 0;
      const stringValue = value.toString();
      if (value.length > 4) {
        const k = stringValue.substring(-6, 2);
        const j = stringValue.substring(2, 3);
        return `${k},${j}k`;
      }
      return stringValue;
    }
  }
};
</script>

<style lang="scss" scoped>

.dashboard-profile {
  padding: 16px;
  padding-bottom: 0;
  overflow: hidden;
  min-width: 220px;
}

.profile-section {
  height: 500px;
  max-height: 65px;
  transition: max-height 0.5s ease;
  overflow: hidden;
  &.expanded {
    max-height: 365px;
  }
}

.profile-label {
  display: grid;
  grid-template-columns: 60px 1fr 24px;
  align-items: center;
  width: 100%;
  &:after {
    content: "";
    display: block;
    clear: both;
  }
}

.profile-picture {
  display: inline-block;
  position: relative;
  margin-right: 10px;
  & > img {
    width: 60px;
    height: 60px;
    border-radius: 50px;
    border: 4px solid transparent;
    float: left;
    @media only screen and (max-width: 768px) {
      width: 60px;
      height: 60px;
    }
  }

  &.highlighted {
    & > img {
      border: 4px solid rgb(54, 112, 206);
    }
  }

  & > .settings-icon {
    position: absolute;
    background: rgba(0, 0, 0, 0.9);
    fill: #fff;
    width: 100%;
    height: 100%;
    border-radius: 100vw;
    opacity: 0;
    transition: opacity 0.25s;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
  }

  &:hover > .settings-icon {
    opacity: 1;
  }
}

.profile-name {
  display: inline-block;
  padding-left: 10px;
  & > h3 {
    padding: 0;
    margin: 0;
    font-weight: bold;
    font-size: 18px;
    max-width: 200px;
    word-wrap: break-word;
  }
  & > p {
    padding: 0;
    margin: 0;
    color: #707070;
    font-size: 14px;
    line-height: 1.3em;
    max-width: 200px;
  }
}

.icon {
  position: relative;
  justify-self: end;
  display: block;
  float: right;
  width: 24px;
  fill: #707070;
  cursor: pointer;
  &:hover {
    fill: #fff;
  }
  transition: fill .25s;
}

.rotatable {
  transition: transform 0.5s;
  transform-origin: 50% 50%;
}

.rotated {
  transform: rotate(180deg);
}

.refreshed {
  animation-name: refresh;
  animation-duration: 1s;
  transition: transform 0.5s;
  transform-origin: 50% 50%;
}

.other-profiles {
  ul {
    margin-top: 8px;
    margin-bottom: 0;
    height: 225px;
    overflow: auto;
    border-top: 1px solid #707070;
    list-style: none;
    padding: 0;
    min-width: 230px;
    background-color: #252525;
    & li {
      display: grid;
      grid-template-columns: 45px 1fr;
      align-items: center;
      background-color: #222;
      transition: background-color 0.25s ease;
      cursor: pointer;
      padding: 10px;
      &:first-child {
        border-top: 0;
      }
      border-top: 1px solid #707070;
      &:hover {
        background-color: #333;
      }
    }
    & .profile-name {
      & h3 {
        font-size: 16px;
        overflow: hidden;
        word-wrap: break-word;
        max-width: 200px;
      }
      & p {
        font-size: 12px;
        word-wrap: break-word;
        max-width: 200px;
      }
    }
  }

  .other-profile-picture {
    & img {
      width: 45px;
      height: 45px;
      border-radius: 30px;
    }
  }

  .add-profile-button {
    cursor: pointer;
    border-radius: 0 0 10px 10px;
    font-size: 20px;
    padding-right: 25px;
    font-weight: bold;
    text-align: center;
    display: flex;
    justify-content: center;
    height: 50px;
    background: linear-gradient(
      135deg,
      rgb(54, 112, 206) 0%,
      rgb(86, 204, 192) 70%
    );

    & svg {
      width: 24px;
      margin-right: 10px;
      fill: #fff;
    }

    & p {
      text-align: left;
      display: block;
      line-height: 50px;
      font-size: 20px;
      padding: 0;
      margin: 0;
    }
  }
}

.followers-label {
  display: grid;
  grid-template-columns: repeat(2, 1fr) 100px;
  align-items: center;
  margin-top: 10px;

  @media (min-width: 380px) and (max-width: 768px) {
    grid-template-columns: repeat(2, 125px) 1fr;
  }
}

.followers {
  padding: 3px;
  text-align: center;
  display: inline-block;
  & > h3 {
    padding: 0;
    margin: 0;
    font-size: 22px;
    font-weight: bold;
    transition: color 0.1s;

    &.refreshing {
      color: #707070;
    }
  }

  & > p {
    padding: 0;
    margin: 0;
    font-size: 13px;
    color: #707070;
  }
}

.balance-label {
  width: 100%;
  border-top: 1px solid #707070;
  margin-top: 15px;
  padding-top: 5px;
  overflow: hidden;
  min-height: 60px;
}

.balance-title {
  font-size: 18px;
  padding-top: 12px;
  float: left;
  & > h3 {
    padding: 0;
    margin: 0;
    font-weight: bold;
  }
}

.balance {
  padding-top: 10px;
  padding-right: 10px;
  float: right;
  font-size: 22px;
  font-weight: bolder;
  overflow: hidden;
}

.balance-symbol {
  color: #707070;
  font-size: 16px;
}

.plus-icon {
  font-size: 30px;
  line-height: 1.85;
}

.other-profiles ul::-webkit-scrollbar {
  width: 0.4em;
}

.other-profiles ul::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.9);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.other-profiles ul::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: #333;
}

.show-modal-enter-active,
.show-modal-leave-active {
  transition: all 0.25s ease;
}

.show-modal-enter,
.show-modal-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
</style>
